import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackCustom } from '../lib/pixel';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/dwAWRmC8sJHMf5gsuNWN4C/ChatGPT_Image_24_jul_2026,_10_09_14_(1).png';
const TRUST_ITEMS = ['Más de 800 alumnos', 'Pago seguro', 'Garantía de 7 días'];
export function HeroSection() {
  const [ref, visible] = useReveal();
  return <section className="overflow-hidden border-b border-[#2E4F48]/15 bg-[#EFEAE0] px-4 py-5 sm:px-6 md:py-8" data-id="element-175" data-mp="2wjz1r942fb7s">
      <div ref={ref} className={`reveal container mx-auto max-w-3xl text-center ${visible ? 'is-visible' : ''}`} data-id="element-176" data-mp="30lu2abe69kki">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#C2683D]/35 bg-white px-3 py-1 text-[9px] font-bold tracking-[0.16em] text-[#1C3B36] shadow-sm md:text-[10px]" data-id="element-177" data-mp="2mte5vtfs0ksk">
          <span className="text-[#C2683D]" data-id="element-178" data-mp="3fht9zkxddip4">✦</span>
          FORMACIÓN PROFESIONAL
        </div>

        <h1 className="mx-auto mt-3 max-w-3xl font-serif text-[30px] font-bold leading-[1.04] tracking-tight text-[#1C3B36] sm:text-4xl md:mt-4 md:text-5xl lg:text-[3.5rem]" data-id="element-179" data-mp="3ka34zfdcd8y9">
          Formación Completa en{' '}
          <span className="italic text-[#C2683D]" data-id="element-180" data-mp="2bfrp20z8tbqs">Biodecodificación Integral</span>
        </h1>

        <p className="mx-auto mt-3 max-w-2xl text-sm font-medium leading-relaxed text-[#44574F] md:mt-4 md:text-base" data-id="element-181" data-mp="2p6wkeqvkvhvb">
          Comprendé el origen emocional de los síntomas y aprendé herramientas
          prácticas para aplicar la Biodecodificación en tu vida o en tu práctica
          profesional.
        </p>

        {/* Transparent mockup, intentionally compact to keep the CTA in the first viewport */}
        <div className="mx-auto mt-3 w-full max-w-[190px] sm:max-w-[220px] md:mt-4 md:max-w-[260px]" data-id="element-182" data-mp="3823dtnzr327u">
          <img src={PRODUCT_IMG} alt="Formación Premium de Biodecodificación Integral con sus tomos y recursos" className="w-full animate-float object-contain drop-shadow-[0_12px_24px_rgba(28,59,54,0.2)]" data-id="element-183" data-mp="33306fwwasjwp" />
        </div>

        <div className="mt-3 md:mt-4" data-id="element-184" data-mp="38umn2grn8or8">
          <a href="#premium" onClick={() => trackCustom('ViewPricingIntent', {
          source: 'hero'
        })} className="inline-flex w-full items-center justify-center rounded-xl bg-[#1C3B36] px-7 py-3.5 text-sm font-bold tracking-[0.12em] text-white shadow-[0_10px_24px_rgba(28,59,54,0.24)] transition-all hover:-translate-y-1 hover:bg-[#2E4F48] sm:w-auto" data-id="element-185" data-mp="38vo1mv7vbtdp">
            QUIERO COMENZAR HOY
          </a>
        </div>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-[#44574F] md:text-xs" data-id="element-186" data-mp="kulsjbjrzjs">
          {TRUST_ITEMS.map((item, index) => <span key={item} className="inline-flex items-center gap-1" data-id="element-187" data-mp="aantvachdwja" data-mpi={index}>
              {index === 0 ? <span className="text-[#C2683D]" data-id="element-188" data-mp="ee2ao388ugxs">★★★★★</span> : <span className="text-[#C2683D]" data-id="element-189" data-mp="ef3vv0iz4jt8">✓</span>}
              {item}
            </span>)}
        </div>
      </div>
    </section>;
}